import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { getBreadCrumbs, transformProperties } from "utils"
import TermsLayout from "./TermsLayout"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  mainTitleBlock: () => import("./MainTitle"),
  titleTextAndMediaBlock: () => import("./TitleTextAndMedia"),
}

const Terms = ({ data, locale }: Props) => {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <TermsLayout breadCrumbs={breadCrumbs}>
      {blocks?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              locale={locale}
              props={{ breadCrumbs }}
            />
          )
        },
      )}
    </TermsLayout>
  )
}

export default Terms
